import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

import DropdownField from './DropdownField';

class SelectFieldValid extends ValidatorComponent {
  render() {
    const {
      title = '',
      onChange = () => {},
      // validators = [],
      // errorMessages = [],
      name,
      children,
      value
    } = this.props;
    const { isValid } = this.state;
    return (
      <DropdownField
        error={!isValid && this.getErrorMessage()}
        onChange={onChange}
        title={title}
        width="100%"
        name={name}
        city={value}>
        {children}
      </DropdownField>
    );
  }
}

export default SelectFieldValid;



// WEBPACK FOOTER //
// ./src/components/NewContact/SelectFieldValid.js